import React from 'react';
import classNames from 'classnames';

export function PopupBody({ className = '', children }) {
    return (
        <div
            className={classNames('modal-body', className)}
            onClick={e => e.stopPropagation()}
        >
            {children}
        </div>
    )
}

